// src/components/strumenti/SpazioDiscoTVCC.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function SpazioDiscoTVCC() {
  const [canali, setCanali] = useState("");
  const [bitrate, setBitrate] = useState("");
  const [giorni, setGiorni] = useState("");

  const n = leggiNumero(canali)||0;
  const kbps = leggiNumero(bitrate)||0;
  const gg = leggiNumero(giorni)||0;

  const bytesAlSecondoPerCanale = kbps*1000/8; // kbps -> bit/s -> /8 = byte/s
  const bytesTotali = bytesAlSecondoPerCanale * 86400 * gg * n;
  // W442: TB e GB decimali, come sono venduti i dischi (1 TB = 10¹² byte); sotto anche in TiB (binari)
  const GBTotali = bytesTotali / 1e9;
  const TBTotali = bytesTotali / 1e12;
  const TiBTotali = bytesTotali / 1024**4;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>N° canali/telecamere</label>
          <input value={canali} onChange={e=>setCanali(e.target.value)} style={inp} placeholder="Es. 8"/>
        </div>
        <div>
          <label style={lbl}>Bitrate per canale (kbps)</label>
          <input value={bitrate} onChange={e=>setBitrate(e.target.value)} style={inp} placeholder="Es. 4096"/>
        </div>
        <div>
          <label style={lbl}>Giorni di conservazione</label>
          <input value={giorni} onChange={e=>setGiorni(e.target.value)} style={inp} placeholder="Es. 30"/>
        </div>
      </div>

      <div style={{ background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Spazio disco necessario</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#6d28d9" }}>
          {GBTotali>0 ? (TBTotali>=1 ? TBTotali.toLocaleString("it-IT",{maximumFractionDigits:2}) : GBTotali.toLocaleString("it-IT",{maximumFractionDigits:1})) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{TBTotali>=1 ? "TB" : "GB"}</span>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        {TBTotali>0 && <>Pari a {TiBTotali.toLocaleString("it-IT",{maximumFractionDigits:2})} TiB (unità binarie, come le mostrano alcuni registratori). </>}TB e GB decimali, come sono venduti i dischi. Calcolo su bitrate costante dichiarato — la registrazione solo su movimento riduce lo spazio reale necessario.
      </div>

      <button onClick={()=>{setCanali("");setBitrate("");setGiorni("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
